export enum Breakpoints {
  XS = 0,
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  XXL = 1536,
  XXXL = 1920,
}

export const enabledOnAllBreakpoints: Array<keyof typeof Breakpoints> = [
  "XS",
  "SM",
  "MD",
  "LG",
  "XL",
  "XXL",
  "XXXL",
];
